import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0125',
    ecrans: ['00-2']
});
